import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify"; 
import AppPricingAppCount from "../components/AppPricingAppCount";
import StripePaymentForm from "../components/StripePaymentForm";

const AppPricingPacks = ({selectedAppSlug}) => {
  const [showPopup, setShowPopup] = useState(false);
  const handlePopupOpen = () => setShowPopup(true);
  const handlePopupClose = () => setShowPopup(false);
  const [selectedTab, setSelectedTab] = useState("annually");

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPaymentCard, setShowPaymentCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [zipCode, setZipCode] = useState(""); 
  const [country, setCountry] = useState(""); 
  const [userDetail, setUserDetail] = useState({email: null}); 

  //Handle Countinue Button
  const handleContinue = () => {
    if (country.trim() === "") {
      toast.error("Country is required");
    } else if(zipCode.trim() === ""){
      toast.error("ZIP/Postcode is required");
    } else {
      setLoading(true); 
      setTimeout(() => {
        setLoading(false);
        setShowPaymentCard(true);
      }, 300);
    }
  };

  useEffect(() => {
    try {
        // Retrieve user details from session storage
        const storedUser = sessionStorage.getItem("user_detail");
        if (storedUser) {
            setUserDetail(JSON.parse(storedUser));
        }
    } catch (error) {
       // console.error("Error retrieving user details:", error);
    }
  }, []);

  //Add Hidden overflow in body
  useEffect(() => {
    document.body.style.overflow = showPopup || showPaymentPopup ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [showPopup,showPaymentPopup]);

  //Handle Swich price Toggle
  const handleToggle = () =>
    setSelectedTab(selectedTab === "monthly" ? "annually" : "monthly");

  //Handle Open Payment Popup
  const handlePaymentPopupOpen = (plan) => {
    setSelectedPlan(plan);
    setShowPaymentPopup(true);
  };

  //Handle Close Payment Popup
  const handlePaymentPopupClose = () => {
    setShowPaymentCard(false);
    setShowPaymentPopup(false);
  };
 
  //Plan Prices
  const discountPercent = 70;

  const applyDiscount = (price) => {
    if (price === 0) return 0;
    const discountedPrice = price - (price * discountPercent) / 100;
    return discountedPrice;
  };

  //Plan Prices
  const pricingPlans = {
    monthly: [
      {
        id: 1,
        name: "Free",
        price: applyDiscount(0),
        description: "Good for testing purposes",
        features: [
          "Unlimited websites",
          "1000 views per app",
          "2 widgets per app",
        ],
        plan_type: "Monthly",
      },
      {
        id: 2,
        name: "Basic",
        price: applyDiscount(10),
        description: "Best for low-traffic websites",
        features: [
          "Unlimited websites",
          "10,000 views per app",
          "5 widgets per app",
        ],
        plan_type: "Monthly",
      },
      {
        id: 3,
        name: "Pro",
        price: applyDiscount(15),
        description: "Best for growing businesses",
        features: [
          "Unlimited websites",
          "80,000 views per app",
          "9 widgets per app",
        ],
        plan_type: "Monthly",
      },
      {
        id: 4,
        name: "Premium",
        price: applyDiscount(20),
        description: "Best for high-traffic websites",
        features: [
          "Unlimited websites",
          "Unlimited views per app",
          "21 widgets per app",
        ],
        plan_type: "Monthly",
      },
    ],
    annually: [
      {
        id: 1,
        name: "Free",
        price: applyDiscount(0),
        description: "Good for testing purposes",
        features: [
          "Unlimited websites",
          "1000 views per app",
          "2 widgets per app",
        ],
        plan_type: "Annually",
      },
      {
        id: 2,
        name: "Basic",
        price: applyDiscount(100),
        description: "Best for low-traffic websites",
        features: [
          "Unlimited websites",
          "10,000 views per app",
          "2 widgets per app",
        ],
        plan_type: "Annually",
      },
      {
        id: 3,
        name: "Pro",
        price: applyDiscount(150),
        description: "Best for growing businesses",
        features: [
          "Unlimited websites",
          "80,000 views per app",
          "9 widgets per app",
        ],
        plan_type: "Annually",
      },
      {
        id: 4,
        name: "Premium",
        price: applyDiscount(200),
        description: "Best for high-traffic websites",
        features: [
          "Unlimited websites",
          "Unlimited views per app",
          "21 widgets per app",
        ],
        plan_type: "Annually",
      },
    ],
  };

  //Country List
  const countries = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia",
    "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
    "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina",
    "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia",
    "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China",
    "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
    "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
    "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea",
    "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
    "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati",
    "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
    "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives",
    "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
    "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
    "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
    "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea",
    "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
    "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino",
    "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
    "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa",
    "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland",
    "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
    "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
    "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
    "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];

  return (
    <>
      <div className="container">
        <div className="app-pricing-page">
          <div className="every-plan-includes">
            <p>Every plan includes</p>
            <ul>
                <li>
                    <button onClick={handlePopupOpen}>
                        <img src={`${process.env.PUBLIC_URL}/images/catalog/google-reviews.png`} alt="google-reviews" />
                        <span>Google Reviews</span>
                    </button>
                </li>
                <li>
                    <button onClick={handlePopupOpen}>
                        <img src={`${process.env.PUBLIC_URL}/images/catalog/whats-app-chat.png`} alt="whats-app-chat" />
                        <span>WhatsApp Chat</span>
                    </button>
                </li>
                <li>
                    <button onClick={handlePopupOpen}>
                        <img src={`${process.env.PUBLIC_URL}/images/catalog/countdown-timer.png`} alt="countdown-timer" />
                        <span>Countdown Timer</span>
                    </button>
                </li>
                <li>
                    <button onClick={handlePopupOpen}>
                        <img src={`${process.env.PUBLIC_URL}/images/catalog/testimonials.png`} alt="testimonials" />
                        <span>Testimonials Slider Reviews</span>
                    </button>
                </li>
                <li>
                    <button onClick={handlePopupOpen}>
                        <img src={`${process.env.PUBLIC_URL}/images/catalog/click-to-call.png`} alt="click-to-call" />
                        <span>Click to Call</span>
                    </button>
                </li>
                <li>
                    <button onClick={handlePopupOpen}>
                        <span className="see-all-app">+ <AppPricingAppCount /></span>
                        <span>See All App</span> 
                    </button>
                </li>
            </ul>
        </div>

          {/* Toggle Tabs */}
          <div className="button-manuly">
            <div className="text-buton">Monthly</div>
            <div className="form-group">
              <input
                type="checkbox"
                id="toggle_1"
                className="chkbx-toggle"
                checked={selectedTab === "annually"}
                onChange={handleToggle}
              />
              <label htmlFor="toggle_1"></label>
            </div>
            <div className="text-buton">Annually</div>
          </div>

          {/* Pricing Cards */}
          <div className="row">
            {pricingPlans[selectedTab].map((plan, index) => (
              <div className="col-md-3" key={index}>
                <div
                  className={`google-reviews-tabe-box ${
                    plan.name === "Pro" ? "google-reviews-tabe-box-active" : ""
                  }`}
                >
                  <h4>{plan.name}</h4>
                  <p>{plan.description}</p>
                  {/*<div className="price-box">
                    <i>$</i>
                    {plan.price}
                    <em> / {selectedTab === "monthly" ? "mo" : "yr"}</em>
                  </div>*/}

                  <div className="price-box">
                    {plan.price > 0 ? (
                      <>
                       
                        <div className="discounted-price">
                          ${plan.price.toFixed(2)}
                          <div className="original-price">
                          ${(plan.price / (1 - discountPercent / 100)).toFixed(2)}
                        </div>
                          <em> / {selectedTab === "monthly" ? "mo" : "yr"}</em>
                        </div>
                      </>
                    ) : (
                      <div className="discounted-price">
                        $0<em> / {selectedTab === "monthly" ? "mo" : "yr"}</em>
                      </div>
                    )}
                  </div>

                  {(() => {
                    const monthlyPlan = pricingPlans.monthly[index];
                    const annualPlan = pricingPlans.annually[index];

                    const monthlyTotal = monthlyPlan.price * 12;
                    const annualTotal = annualPlan.price;

                    //const discountPercent = Math.round(((monthlyTotal - annualTotal) / monthlyTotal) * 100);
                    const amountSaved = monthlyTotal - annualTotal;

                    const isCurrentPlan = String(userDetail.plan_id) === String(plan.id);
                    const isFreePlan = plan.price === 0;

                    return (
                      <>
                       {isCurrentPlan ? (
                          <div className="current-plan-box get-box">Current Plan</div>
                        ) : (
                          <>
                            {/*amountSaved > 0 && (
                              <p className="you-save">
                                You save <strong>${amountSaved}</strong> a year
                              </p>
                            )*/}
                            <div
                              className="current-plan-box get-box"
                              onClick={!isFreePlan ? () => handlePaymentPopupOpen(plan) : undefined}
                              style={{ cursor: isFreePlan ? "default" : "pointer" }}
                            >
                              {discountPercent > 0
                                ? selectedTab === "monthly"
                                  ? `Get ${discountPercent}% off`
                                  : `Save ${discountPercent}%`
                                : isFreePlan
                                ? "Get Started"
                                : "Choose Plan"}
                            </div>
                          </>
                        )}
                      </> 
                    );
                  })()}
                  <div className="all-95">
                    All <AppPricingAppCount /> Upgadeify apps
                    <br /> + upcoming apps
                  </div>
                  <ul>
                    {plan.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

            <div className="all-paid-plans-box-tav-two">
              <h2>Unlock the power of All Apps Pack</h2>
              <div className="row">
                  <div className="col-md-12">
                      <ul>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> The world's finest tools for website enhancement
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> Gain access to the full catalog of top-rated website widgets
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> Take your website to the next level with your own suite of customizable widgets
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> Perfect for agencies - enhance your clients' websites more effectively with All Apps Pack
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path></svg> AI-generated review summaryGoogle Reviews, Instagram Feed, WhatsApp Chat, Event Calendar, and <a href="/"><AppPricingAppCount /> more powerful apps</a>
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> An unrivaled pack of widgets to display reviews, social content, forms, maps, calendars, pricing and etc.
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path>
                            </svg> Multiple review sorting options
                          </li>
                          <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M13.576 3.576a.6.6 0 0 1 .918.765l-.07.083-8.25 8.25a.6.6 0 0 1-.765.07l-.083-.07-3.75-3.75a.6.6 0 0 1 .765-.918l.083.07L5.75 11.4l7.826-7.825Z"></path></svg> One subscription for all apps - an easy and must-grab deal that saves you $1000s
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
        </div>
      </div>

      {/*Apps Popup Modal */}
      {showPopup && (
        <div className="custom-popup-overlay price_popup">
            <div className="custom-popup-content">
                <button className="popup-close-btn" onClick={handlePopupClose}>×</button>
                <h2 className="price_popup_title">All Apps</h2>
                <div className="price_popup_content">
                  <div className="price_popup_list_box">
                    {/* <h3>Reviews</h3> */}
                    <ul className="price_popup_list">
                        <li>Google Reviews</li>
                        <li>WhatsApp Chat</li>
                        <li>Click To Call</li>
                        <li>Countdown Timer</li>
                        <li>Testimonials Slider</li>
                        <li>Cookie Consent</li>
                        <li>Age Verification</li>
                        <li>Business Hours</li>
                        <li>Announcement Bar</li>
                        <li>Pricing Table</li>
                    </ul>
                  </div>
                  <div className="price_popup_list_box">
                    {/* <h3>Social Media</h3> */}
                    <ul className="price_popup_list">
                      <li>Number Counter</li>
                      <li>Photo Gallery</li>
                      <li>Back to Top</li>
                      <li>Social Media Icons</li>
                      <li>Facebook Like Button</li>
                      <li>Facebook Share Button</li>
                      <li>QR Code</li>
                      <li>Logo Showcase</li>
                      <li>Team Showcase</li>
                      <li>FAQ</li>
                    </ul>
                  </div>
                </div>
            </div>
        </div>
      )}

      {/*Payment Popup Modal */}
      {showPaymentPopup && selectedPlan && (
        <div className="custom-popup-overlay price_popup">
          <div className="custom-popup-content">
              <button className="popup-close-btn" onClick={() => handlePaymentPopupClose()}>×</button>
              <div className="price_popup">
                <div className="popup-left">
                  <h2>Order summary</h2>
                  {(() => {
                    //Total Cal
                    const basePrice = parseFloat(selectedPlan.price);
                    const subTotalPrice = basePrice;
                    const totalWithGst = subTotalPrice;

                    // Calculate due date: same day next month
                    const today = new Date();
                    const dueDate =
                      selectedTab === "monthly"
                        ? new Date(today.getFullYear(), today.getMonth() + 1, today.getDate())
                        : new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

                    const formattedDueDate = dueDate.toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    });

                    return (
                        <>
                          <div className="price">
                            ${basePrice.toFixed(2)} / {selectedPlan.plan_type} <small>Inc. GST</small>
                          </div>

                          <div className="summary-item">
                            <h2>Upgadeify Back to Top Basic - {selectedPlan.plan_type}</h2>
                          </div>

                          <div className="summary-item">
                            <span>Subtotal</span>
                            <span>${subTotalPrice.toFixed(2)}</span>
                          </div>

                          <div className="summary-item total">
                            <span>Due today</span>
                            <span>${totalWithGst.toFixed(2)}</span>
                          </div>

                          <div className="summary-item total">
                            <span>Due on {formattedDueDate}</span>
                            <span>${totalWithGst.toFixed(2)}</span>
                          </div>
                        </>
                      );
                  })()}
                </div>

                <div className="popup-right">
                  {/* SHOW FORM */}
                  {!loading && !showPaymentCard && (
                    <>
                      <div className="input-group">
                        <label>Email address</label>
                        <input type="text" value={userDetail?.email} readOnly />
                      </div>

                      <div className="input-group">
                        <label>Country</label>
                        <select
                          id="country"
                          value={country}
                          onChange={(e) => {
                            setCountry(e.target.value);
                          }}
                        >
                          <option value="">Select a country</option>
                          {countries.map((c, idx) => (
                            <option key={idx} value={c}>{c}</option>
                          ))}
                        </select>
                      </div>

                      <div className="input-group">
                        <label>ZIP/Postcode</label>
                        <input
                          type="text"
                          value={zipCode}
                          onChange={(e) => {
                            setZipCode(e.target.value);
                          }}
                        />
                      </div>

                      <div className="input-group">
                        <input type="checkbox" /> Upgrade may send me product updates and offers via email. It is possible to opt-out at any time.
                      </div>

                      <button className="subscribe-btn" onClick={handleContinue}>
                        Continue
                      </button>
                       <ToastContainer />
                    </>
                  )}

                  {/* SHOW LOADER */}
                  {loading && (
                    <div className="loader-overlay">
                      <div className="loader-spinner"></div>
                      <p>Please wait...</p>
                    </div>
                  )}

                  {/* SHOW PAYMENT SECTION */}
                  {!loading && showPaymentCard && (
                    <>
                      <StripePaymentForm selectedPlan={selectedPlan} selectedAppSlug={selectedAppSlug} userDetail={userDetail} zipCode={zipCode} country={country} />
                    </>
                  )}
                </div>  
              </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppPricingPacks;
